export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/wasm-module-2.5472e38b76980574.js");
}
